module.exports = __webpack_public_path__ + "img/readPointSample.png";